import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import moment from 'moment'
export default {
  props: {
    title: String,
    serviceOrderId: Number,
    service: Object,
    disabled: Boolean,
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (this.service) {
      this.currentService = this.service
      this.startStepDateTime = this.service.dateTimeStartStep
      this.endStepDateTime = this.service.dateTimeEndStep

      this.currentService.status =
        this.statusStep[this.service.statusStepServiceOrder]
      this.user = this.service.userResponsible

      if (this.service.alertDate) {
        this.alert = true
        this.alertDate = this.service.alertDate
      }

      this.isEditing = true
    }
    await this.getUsers()

    this.userName = this.user.id ? this.user.name : this.userLogged.name
  },

  data: () => ({
    institution: {},
    alertDate: null,
    alert: false,
    step: 0,
    selectedStartTab: 0,
    selectedEndTab: 0,
    errorMessage: '',
    isEditing: false,
    loading: false,
    firstValid: false,
    error: false,
    dialog: false,
    startStepDateTimeError: false,
    userName: null,
    startStepDateTime: null,
    endStepDateTime: null,
    userLogged: {},
    institution: {},
    user: {},
    currentService: {
      id: 0,
      description: '',
      dateTimeStartStep: null,
      dateTimeEndStep: null,
      timeSpent: null,
      status: -1,
    },
    statusStep: [
      'Manutenção terceirizada in loco',
      'Manutenção terceirizada externa',
      'Manutenção interna',
      'Aguardando peça',
      'Aguardando orçamento',
      'Aguardando avaliação externa',
      'Aguardando aprovação de orçamento',
      'Aguardando liberação do setor',
      'Deslocamento',
      'Equipamento não encontrado',
    ],
    responsibleUsers: [],
    timeRules: [(v) => v == null || /^\d\d:\d\d/.test(v) || 'Tempo inválido'],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    async getUsers() {
      await this.apiService
        .get(`user/allInst/${this.institutionId}`, true, false)
        .then((response) => {
          this.responsibleUsers = response.content.filter(
            (x) =>
              x.userType < 4 ||
              x.userType === 8 ||
              (this.user && x.name == this.user.name) ||
              x.name == this.userName ||
              x.id == this.userLogged.id
          )

          if (this.userLogged.mainType == 1) {
            this.responsibleUsers = this.responsibleUsers.filter(
              (x) =>
                x.userType > 1 ||
                (this.user && x.name == this.user.name) ||
                x.name == this.userName ||
                x.id == this.userLogged.id
            )
          }

          if (this.institution.userType == 2) {
            this.responsibleUsers = this.responsibleUsers.filter(
              (x) =>
                (x.userType > 2 && x.userType != 8) ||
                (this.user && x.name == this.user.name) ||
                x.name == this.userName ||
                x.id == this.userLogged.id
            )
          }
        })
    },

    close() {
      this.$emit('close')
    },

    validateDates() {
      if (
        !!this.startStepDateTime &&
        !!this.endStepDateTime &&
        moment(this.startStepDateTime).isAfter(moment(this.endStepDateTime))
      ) {
        this.$toast.warning(
          this.$t('A data de fim não pode ser antes da data de início')
        )
        return false
      }
      return true
    },

    async next() {
      if (this.step === 0) {
        if (
          this.$refs.firstForm.validate() &&
          this.startStepDateTime &&
          this.validateDates()
        ) {
          this.submit()
        } else {
          this.startStepDateTimeError = true
        }
      } else {
        this.$emit('confirm')
      }
    },

    setStartStepNowDate() {
      this.startStepDateTime = !this.startStepDateTime
        ? new Date()
        : this.startStepDateTime
    },

    setEndStepNowDate() {
      this.endStepDateTime = !this.endStepDateTime
        ? new Date()
        : this.endStepDateTime
    },

    setAlertDateNowDate() {
      this.alertDate = !this.alertDate ? new Date() : this.alertDate
    },

    async submit() {
      this.loading = true

      const user = this.responsibleUsers.find((x) => x.name == this.userName)

      const userId = user ? user.id : this.user.id

      const service = {
        Id: this.currentService.id,
        UserResponsibleId: userId,
        Description: this.currentService.description,
        DateTimeStartStep: Utils.nowDatetimeFormat(this.startStepDateTime),
        DateTimeEndStep: Utils.nowDatetimeFormat(this.endStepDateTime),
        TimeSpent: this.currentService.timeSpent,
        StatusStepServiceOrder: this.statusStep.indexOf(
          this.currentService.status
        ),
        ServiceOrderId: this.serviceOrderId,
        alertDate: Utils.nowDatetimeFormat(this.alertDate),
      }

      service.DateTimeEndStep == 'Invalid date'
        ? (service.DateTimeEndStep = null)
        : ''

      let url = 'service/add'

      if (this.isEditing) {
        url = 'service/edit'
      }

      if (!this.alert) {
        service.alertDate = null
      }

      await this.apiService
        .post(url, service)
        .then(() => {
          if (
            service.StatusStepServiceOrder == 5 ||
            service.StatusStepServiceOrder == 1
          ) {
            this.$emit('setExternal')
          }
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    getInstitution() {
      this.instLoading = true

      this.apiService
        .get(`institution/${this.institutionId}`)
        .then((response) => {
          this.institution = response.content
          this.instLoading = false
        })
        .catch(() => {
          this.instLoading = false
        })
    },
  },

  watch: {
    alert(nv) {
      console.log(this.institution)
      if (nv) {
        switch (this.currentService.status) {
          case 'Manutenção terceirizada in loco':
            if (this.institution.onsiteOutsourcedMaintenance) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.onsiteOutsourcedMaintenance, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Manutenção terceirizada externa':
            if (this.institution.externalOutsourcedMaintenance) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.externalOutsourcedMaintenance, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Manutenção interna':
            if (this.institution.internalMaintenance) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.internalMaintenance, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando peça':
            if (this.institution.waintingForPart) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingForPart, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando orçamento':
            if (this.institution.waintingBudget) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingBudget, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando avaliação externa':
            if (this.institution.waintingExternalAppraisal) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingExternalAppraisal, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando aprovação de orçamento':
            if (this.institution.waintingBudgetApproval) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingBudgetApproval, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando liberação do setor':
            if (this.institution.waitingDepartmentRelease) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waitingDepartmentRelease, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Deslocamento':
            if (this.institution.displacement) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.displacement, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          default:
            break
        }
      }
    },

    startStepDateTime: {
      deep: true,
      handler() {
        this.startStepDateTimeError = false
      },
    },
  },
}
